module.exports = __webpack_public_path__ + "img/centro-comercial-cba.bcf4ccdc.jpg";